<template>
	<NuxtLink :to="logoLink">
		<slot />
	</NuxtLink>
</template>

<script setup>
	const config = useAppConfig();
	const {getLang} = useLang();
	const logoLink = computed(() => {
		const currLanguage = getLang();

		if (config.multiHost?.length) {
			const host = config.multiHost.find(host => host.lang == currLanguage.code);
			if (host) return host.host;
		}

		return config.lang == currLanguage.code ? '/' : currLanguage.base_url;
	});
</script>
